import { ca } from '@cian/analytics';
import { EPageBlock } from '../../../types/analytics';

type TAction = 'show_sopr' | 'Click';

const trackMortgageProgramsEvent = (action: TAction) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action,
    label: 'Block',
    page: {
      extra: {
        block: EPageBlock.MortgagePrograms,
      },
    },
  });
};

export const trackMortgageProgramsListShow = () => trackMortgageProgramsEvent('show_sopr');
export const trackMortgageProgramClick = () => trackMortgageProgramsEvent('Click');
